import { motion } from "framer-motion";

const TITLE_ANIM = {
  initial: { opacity: 0, y: 14 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

const STEP_SHELL_ANIM = {
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.55, ease: "easeOut" },
};

export const SectionTitle = ({ children, kicker }) => (
  <div className="text-center mb-8">
    {kicker && (
      <span className="serif inline-block text-sm tracking-[0.25em] uppercase text-[#b8860b] mb-2">
        {kicker}
      </span>
    )}
    <motion.h2
      {...TITLE_ANIM}
      className="serif text-2xl sm:text-3xl font-semibold text-[#4C1D95]"
    >
      {children}
    </motion.h2>
  </div>
);

export const StepShell = ({ children }) => (
  <motion.section
    {...STEP_SHELL_ANIM}
    className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-10"
  >
    {children}
  </motion.section>
);
